import MarkdownGithub from "components/markdown/MarkdownGithub";
import Box from "ds/components/Box";
import PageInfoHeaderWrapper from "ds/components/PageInfoHeader/Wrapper";
import PageInfoHeaderTitle from "ds/components/PageInfoHeader/Title";

type ResourceContentProps = {
  name: string;
  markdown: string;
};

const ResourceContent = ({ name, markdown }: ResourceContentProps) => {
  return (
    <>
      <PageInfoHeaderWrapper>
        <PageInfoHeaderTitle title={name} />
      </PageInfoHeaderWrapper>
      <Box grow="1" direction="column" padding="x-large" fullWidth scrollable surfaceColor="primary">
        <MarkdownGithub markup={markdown} />
      </Box>
    </>
  );
};

export default ResourceContent;
